import React from "react";

export const PublishedColumnFormatter = (cellContent, row) => (
	<label className="checkbox checkbox-lg checkbox-single">
		<input type="checkbox" checked={row.is_published} readOnly />
		<span></span>
	</label>
);
